<div class="full-height layout-column">

  <!--Table-->
  <div class="flex layout-column bringoz-table bringoz-table-sticky scrollable"
       [hidden]="!routes.length">

    <!--Table Headers-->
    <div id="header" class="tr layout-row layout-align-start-center">

      <div class="th sticky medium text-ellipsis text-center ">

        <app-bringoz-checkbox (clickEvent)="onToggleSelectAll()"
                              [isChecked]="(!excludeMode && !!selectedIds.length) || (excludeMode && !selectedIds.length)"
                              [isIndeterminate]="(!excludeMode && !!selectedIds.length && routesCount > selectedIds.length) ||
                                                (excludeMode && !!selectedIds.length && ( selectedIds.length !== routesCount))">

        </app-bringoz-checkbox>


        <div class="text-ellipsis text-left" flex translate>Route</div>
      </div>
      <div *ngIf="columns.scheduled?.enabled" class="flex layout-row layout-align-start-center th small text-ellipsis">
        <span translate>Scheduled</span>
        <bringoz-button type="tertiary"
                        class="sort-button"
                        (click)="onSortChange('sortNotBefore')">
          <bringoz-icon [iconName]="sortType?.name === 'sortNotBefore' ?
                        asceDescIconsMap[sortType.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>

      </div>
      <div *ngIf="columns.resource?.enabled" class="th small text-ellipsis flex" translate>Resource</div>

      <div *ngIf="columns.vehiclePlateNumber?.enabled"
           class="flex layout-row layout-align-start-center th small text-ellipsis">
        <span translate>Vehicle plate number</span>
        <bringoz-button type="tertiary"
                        class="sort-button"
                        (click)="onSortChange('sortLogisticVehiclePlateNumber')">
          <bringoz-icon [iconName]="sortType?.name === 'sortLogisticVehiclePlateNumber' ?
                        asceDescIconsMap[sortType?.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>
      </div>

      <div *ngIf="columns.assistants?.enabled" class="flex th small text-ellipsis" translate>Assistants</div>
      <div *ngIf="columns.deliveries?.enabled" class="flex th xxsmall text-ellipsis text-center" translate>Del</div>
      <div *ngIf="columns.accounts?.enabled" class="flex th small text-ellipsis text-center" translate>Accounts
      </div>
      <div *ngIf="columns.totals?.enabled && hasFleetManagementPermission"
           class="flex th small text-ellipsis"
           translate>
        Totals
      </div>
      <div *ngIf="columns.capacityRisks?.enabled && hasFleetManagementPermission"
           class="th small text-ellipsis"
           translate>
        Capacity Risks
      </div>

      <div *ngIf="columns.cost?.enabled" class="th small text-ellipsis flex" translate>Cost</div>
      <div *ngIf="columns.distance?.enabled" class="th small text-ellipsis flex" translate>DISTANCE</div>
      <div *ngIf="columns.alerts?.enabled" class="th small text-center text-ellipsis flex" translate>Warn</div>
      <div *ngIf="columns.progress?.enabled" class="th small text-ellipsis flex" translate>Progress</div>
      <div *ngIf="columns.totalTime?.enabled" class="th small text-ellipsis flex" translate>Total Time</div>
      <div *ngIf="columns.agentOperationalUnits?.enabled" class="th small text-ellipsis flex" translate>Agent
        Operational Units
      </div>
      <div *ngIf="columns.serviceAreas?.enabled" class="th small text-center text-ellipsis margin-right-15 flex"
           translate>Service Area
      </div>

      <!--Dynamic Columns-->
      <div *ngFor="let column of enabledDynamicColumns"
           class="th flex layout-row layout-align-start-center small text-ellipsis">
        <span>{{column.title}}</span>
      </div>

    </div>

    <!--Table Body-->
    <div class="flex layout-column rows-container full-height">

      <!--Repeater-->
      <div class="full-height flex layout-column">
        <cdk-virtual-scroll-viewport [itemSize]="105" class="flex viewport"
                                     (scroll)="getNextBatch()">

          <app-planning-routes-table-row *cdkVirtualFor="let route of routes"
                                         class="item"
                                         [route]="route"
                                         [columns]="columns"
                                         [dynamicColumns]="enabledDynamicColumns"
                                         [isSelected]="(!excludeMode && selectedKeys[route.id]) || (excludeMode && !selectedKeys[route.id])"
                                         [highlighted]="highlightedRoute?.id === route.id"
                                         [show]="showKeys[route.id]"
                                         [hasFleetManagementPermission]="hasFleetManagementPermission"
                                         [serviceAreasMap]="serviceAreasMap"
                                         (onToggle)="onToggleRoute(route)"
                                         (onAssignRoute)="onAssignRoute.emit(route)"
                                         (onAssignRouteAndSelectDriver)="onAssignRouteAndSelectDriver.emit(route)"
                                         (onHandleUnpackedDeliveries)="onHandleUnpackedDeliveries.emit(route)"
                                         (onReoptimizeRoute)="onReoptimizeRoute.emit(route.id)"
                                         (onBlockRoute)="onBlockRoute.emit(route.id)"
                                         (onUnBlockRoute)="onUnBlockRoute.emit(route.id)"
                                         (onResetRoute)="onResetRoute.emit(route.id)"
                                         (onUpdateBranches)="onUpdateBranches.emit(route)"
                                         (onUpdateResource)="onUpdateResource.emit(route)"
                                         (onManageAssistants)="onManageAssistants.emit(route)"
                                         (onChangeRouteColor)="onChangeRouteColor.emit(route)"
                                         (onUpdateLogisticsVehicle)="onUpdateLogisticsVehicle.emit({task: $event.task, route: route})"
                                         (onDeleteRoute)="onDeleteRoute.emit(route.id)"
                                         (onToggleShowRoute)="onToggleShowRoute.emit(route)"
                                         (onPrintIkea)="onPrintIkea.emit(route)"
                                         (onPrint)="onPrint.emit(route.id)"
                                         (onDownloadBillOfLading)="onDownloadBillOfLading.emit(route.id)"
                                         (onPrintBillOfLading)="onPrintBillOfLading.emit(route.id)"
                                         (onPrintLoadingSheet)="onPrintLoadingSheet.emit(route.id)"
                                         (onExport)="onExport.emit(route.id)">

          </app-planning-routes-table-row>

        </cdk-virtual-scroll-viewport>
      </div>
    </div>

  </div>

  <!--Empty State-->
  <div *ngIf="!isLoading && !routes.length"
       class="flex-100 full-height layout-row layout-align-center-center overflow-auto fade-element-in-only">
    <app-empty-state src="assets/images/empty_state/empty_state_routes.png"
                     text="No Routes Found">

    </app-empty-state>
  </div>

</div>
